module.exports = __webpack_public_path__ + "img/Selectold.540affe8.svg";